<template>
  <step-item-wrapper @stepManagerState="setFrom">
    <div>
      <input type="file" id="product-gallery-1" name="product-gallery-1" multiple accept="image/*,video/*"
             class="d-none" @input="onFileChange">
      <label for="product-gallery-1" class="btn btn-primary"
             v-t="`product.single.dashboard.product_gallery_choose_file_button`">
      </label>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6 col-6 my-2" v-for="(file, index) in form.preview" :key="index">
        <img :src="file.file" alt="gallery-image" class="gallery-image">
        <div class="d-block ">
          <button @click="removeImage(index)" type="button"
                  class="btn  btn-danger btn-sm text-center rounded-pill mt-1 ">
            <span class="badge rounded-pill"
                  v-t="`product.single.dashboard.product_gallery_remove_image_button`"></span>
          </button>
        </div>
      </div>
    </div>

  </step-item-wrapper>
</template>

<script>
import {defineComponent} from 'vue'
import StepItemWrapper from "../../../StepItemWrapper.vue";
import axios from "axios";

export default defineComponent({
  name: "StepManagerFormProductGallery1",
  components: {StepItemWrapper},
  data() {
    return {
      form: {}
    }
  },
  methods: {
    setFrom(value) {
      this.form = value
    },
    removeImage(index) {
      // if have selected item(index) in images we remove it from server.


      const removeItemFromServe = this.form.preview[index].file.indexOf('blob') === -1;

      if (removeItemFromServe) {
        let selectedImage = this.form.preview[index].id
        const form = {
          id: this.form.id,
          _method: "DELETE",
          images: [selectedImage],
        };

        this.$store.dispatch('Product/deleteImageProductGalleryInStepManager', form)
            .then(res => {
              this.form.preview.splice(index, 1);
              this.form.images.splice(index, 1);
            })
            .catch((error) => {
              console.log(error);
            })

      } else {
        this.form.preview.splice(index, 1);
      }

    },
    onFileChange(e) {
      // show selected image preview before upload
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        this.form.preview.push({file: URL.createObjectURL(file)});
        this.form.images.push(file)
      }

    },
  }
})
</script>

<style scoped>
.gallery-image {
  width: 150px;;
  height: auto;
  object-fit: contain;
}
</style>